module.exports = __webpack_public_path__ + "assets/img/sf_icon4@2x.ac1bf341.png";